export const COLLABORATION_ANCHOR_ID = 'collaboration';

export const COLLABORATION_TAB_PARAM = 'collaborationTab';
